import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { IAppEnvironment } from '@domain/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { provideFontFamiliesStore, provideUserSettingsStore } from '@studio/common';
import { provideBrandStore } from '@studio/common/brand/brand.provider';
import { metaReducers } from '@studio/common/local-storage/local-storage';
import { NGRX_STORES_CONFIG } from '@studio/common/ngrx.config';
import { provideUserStore } from '@studio/common/user/user.provider';
import { provideCreativeConverterStore } from './pages/manage-view/creative-converter/state/creative-converter.provider';
import { provideDuplicateCreativesStore } from './pages/manage-view/duplicate-creatives/state/duplicate-creative.provider';
import { provideSizeAddStore } from './pages/manage-view/size-add-dialog/state/size-add.provider';
import { provideTranslationPageStore } from './pages/translation-page/state/translation-page.provider';
import { provideGenAIStore } from './shared/ai-studio/state/gen-ai.provider';
import { provideAnimationControlStore } from './shared/animation-control/state/animation-control.provider';
import { provideCreativesStore } from './shared/creatives/state/creatives.provider';
import { provideCreativeSetShowcaseStore } from './shared/creativeset-showcase/state/creativeset-showcase.provider';
import { provideCreativeSetStore } from './shared/creativeset/state/creativeset.provider';
import { provideDisplayCampaignStore } from './shared/display-campaign/state/display-campaign.provider';
import { provideFiltersStore } from './shared/filters/state/filters.provider';
import { provideMediaLibraryStore } from './shared/media-library/state/media-library.provider';
import { provideVersionsStore } from './shared/versions/state/versions.provider';
import { provideFollowCreativeSetStore } from '@studio/manage-view';

export function provideNgRxStores(
    production: IAppEnvironment['production'],
    origins: IAppEnvironment['origins']
): EnvironmentProviders[] {
    return [
        makeEnvironmentProviders([
            {
                provide: NGRX_STORES_CONFIG,
                useValue: {
                    production: production,
                    origins: origins
                }
            }
        ]),
        importProvidersFrom([
            StoreModule.forRoot(
                {},
                {
                    metaReducers,
                    runtimeChecks: {
                        strictActionImmutability: true,
                        strictStateImmutability: true
                    }
                }
            ),
            EffectsModule.forRoot([]),
            StoreDevtoolsModule.instrument({
                logOnly: production
            }),
            StoreRouterConnectingModule.forRoot()
        ]),
        provideAnimationControlStore(),
        provideBrandStore(),
        provideCreativeConverterStore(),
        provideCreativeSetShowcaseStore(),
        provideCreativeSetStore(),
        provideCreativesStore(),
        provideDisplayCampaignStore(),
        provideDuplicateCreativesStore(),
        provideFiltersStore(),
        provideFollowCreativeSetStore(),
        provideFontFamiliesStore(),
        provideGenAIStore(),
        provideMediaLibraryStore(),
        provideSizeAddStore(),
        provideTranslationPageStore(),
        provideUserSettingsStore(),
        provideUserStore(),
        provideVersionsStore()
    ];
}
